import { render, staticRenderFns } from "./MenuShop.vue?vue&type=template&id=0117e76d&scoped=true&"
import script from "./MenuShop.vue?vue&type=script&lang=js&"
export * from "./MenuShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0117e76d",
  null
  
)

export default component.exports